import { FC } from 'react';
import { copy } from './icons/copy';
import { download } from './icons/download';
import { downloadPopup } from './icons/downloadpopup';
import { share } from './icons/share';
import { back } from './icons/back';
import { logo } from './icons/logo';
import { video } from './icons/video';
import { frame } from './icons/frame';
import { share2 } from './icons/share2';
import { arrowRight } from './icons/arrow-right';
import { play } from './icons/play';
import { close } from './icons/close';
import { instagram } from './icons/instagram';
import { mail } from './icons/mail';
import { checkMark } from './icons/check-mark';

export type Icons = {
  close: FC;
  copy: FC;
  download: FC;
  downloadPopup: FC;
  share: FC;
  back: FC;
  logo: FC;
  video: FC;
  frame: FC;
  share2: FC;
  arrowRight: FC;
  play: FC;
  instagram: FC;
  mail: FC;
  checkMark: FC;
};

export const icons: Icons = {
  close,
  copy,
  download,
  downloadPopup,
  share,
  back,
  logo,
  video,
  frame,
  share2,
  arrowRight,
  play,
  instagram,
  mail,
  checkMark,
};
